import { locale } from '../config/config-cdn';

const getLocaleString = (data, currentLocale) => {
	if (!data) return '';
	return data[locale[currentLocale]] || data[Object.keys(data)[0]];
};

const getEnglishOrLocaleString = (data, currentLocale) => {
	if (!data) return '';
	return data['en-US'] || getLocaleString(data, currentLocale);
};

export { getLocaleString, getEnglishOrLocaleString };
